import React, { useState } from 'react';
import {   faChevronRight,   faChevronDown,  faExternalLink } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import '../css/TreeNode.css';

const TreeNode = ({ node, nodeKey, onLinkClick, depth = 0, path = '', expandedNodes, setExpandedNodes }) => {
  const fullPath = path ? `${path}/${nodeKey}` : nodeKey;
  const expanded = !!expandedNodes[fullPath];

  const isObject = value => typeof value === 'object' && value !== null;

  const handleToggle = () => {
    setExpandedNodes(prev => ({
      ...prev,
      [fullPath]: !prev[fullPath]
    }));
  };

  const arrowIcon = expanded ?   faChevronDown :   faChevronRight;

  if (isObject(node)) {
    return (
      <div className="tree-node">
        <div className="tree-row" onClick={handleToggle}>
          <div className="tree-cell icon-cell">
            <FontAwesomeIcon icon={arrowIcon} />
          </div>
          <div className="tree-cell key-cell">
            {nodeKey}
          </div>
        </div>
        {expanded && Object.keys(node).map(key => (
          <TreeNode
            key={key}
            node={node[key]}
            nodeKey={key}
            path={fullPath}
            onLinkClick={onLinkClick}
            depth={depth + 1}
            expandedNodes={expandedNodes}
            setExpandedNodes={setExpandedNodes}
          />
        ))}
      </div>
    );
  }

  return (
    <div className="tree-node">
      <div className="tree-row">
        <div className="tree-cell key-cell">
          {nodeKey}: {node ? new Date(node).getFullYear() : ''}{' '}
          <span
            className="pseudolink"
            role="button"
            tabIndex={0}
            onClick={() => onLinkClick(node)}
            onKeyDown={(e) => {
              if (e.key === 'Enter') onLinkClick(node);
            }}
          >
            <FontAwesomeIcon className="date-icon" icon={faExternalLink} />
          </span>
        </div>
      </div>
    </div>
  );
};

export default TreeNode;
